/* eslint-disable */
import throwI18nInvalidLocalesError from '../../../Errors/I18n/I18nInvalidLocales.error';
import i18nValidateLocale from '../ValidateLocale/I18nValidateLocale.support';

/**
 * Determine if a provided `locale` is indeed a valid `locale`
 * @export
 * @param {any} locales The `locales` to check
 * @param {string} ltr The `ltr` value
 * @param {string} rtl The `rtl` value
 * @returns {boolean} Whether or not the provided `locale` is indeed valid
 */
const i18nValidateLocales = (locales, ltr, rtl) => {
  if (!Array.isArray(locales) || locales.length === 0) {
    return throwI18nInvalidLocalesError(locales);
  }
  locales.forEach((locale) => {
    i18nValidateLocale(locale, ltr, rtl);
  });
  return true;
};

export default i18nValidateLocales;
